export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/WY-af6c8e758bd41805221b38559f27c09b.PNG";